import { render } from "./itemLoto.vue?vue&type=template&id=0451b308"
import script from "./itemLoto.vue?vue&type=script&lang=js"
export * from "./itemLoto.vue?vue&type=script&lang=js"

import "./itemLoto.vue?vue&type=style&index=0&id=0451b308&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__